"use client";

import Link from "next/link";
import { usePostHog } from "posthog-js/react";

/**
 * A signup/trial CTA that records a PostHog event tagged with the SEO surface
 * it was clicked from. This is what powers the "landing → onboarding → first
 * plan" funnel broken out by SEO entry (Proposal 10, analytics).
 */
export function SeoCta({
  href = "/signup",
  surface,
  slug,
  locale,
  children,
  className,
  variant = "primary",
}: {
  href?: string;
  surface: string;
  slug?: string;
  locale: string;
  children: React.ReactNode;
  className?: string;
  variant?: "primary" | "outline";
}) {
  const posthog = usePostHog();

  const base =
    "inline-flex items-center justify-center rounded-md px-6 py-3 font-medium transition-opacity";
  const styles =
    variant === "primary"
      ? "bg-primary text-primary-foreground hover:opacity-90"
      : "border border-border text-foreground hover:bg-accent";

  return (
    <Link
      href={href}
      className={`${base} ${styles} ${className ?? ""}`}
      onClick={() =>
        posthog?.capture("seo_cta_click", {
          seo_surface: surface,
          seo_slug: slug,
          seo_locale: locale,
          cta_href: href,
        })
      }
    >
      {children}
    </Link>
  );
}
